import React from 'react';
import PropTypes from 'prop-types';
import NavActions from '../../actions';
import {getDataAttribute, getWindowLocationOrigin} from 'epic-common/src/browser';
import LocaleIcon from './LocaleIcon';
import getCurrentLocale from '../../utils/localeUtils';
import root from 'window-or-global';

export default class Locale extends React.PureComponent {
    constructor(props) {
        super(props);
        this.warned = false;
    }

    static propTypes = {
        localeOptions: PropTypes.array,
        isActive: PropTypes.bool,
        locale: PropTypes.string,
        hideCallToAction: PropTypes.bool,
        hideSignIn: PropTypes.bool
    };

    static contextTypes = {
        isMobile: PropTypes.bool,
        messages: PropTypes.object,
        globalLinkOnClick: PropTypes.func
    };


    onClick = (e) => {
        const href = e.currentTarget.href;
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            const index = getDataAttribute(e.currentTarget, 'index');
            if (!index) return;
            const locale = this.props.localeOptions[index];
            if (locale && locale.onClick && typeof locale.onClick === 'function') {
                locale.onClick(e);
            }
        }
    };

    getHref(locale) {
        let url = getWindowLocationOrigin() + root.location.pathname + root.location.search;
        const lang = locale.lang.replace(/_/, '-');
        if (url.indexOf('lang=') > -1) {
            url = url.replace(/lang=[\w_-]*/, `lang=${lang}`);
        } else if (url.indexOf('?') > -1) {
            url += `&lang=${lang}`;
        } else {
            url += `?lang=${lang}`;
        }

        return url + root.location.hash;
    }

    close = () => {
        NavActions.mobileLocaleActive(false);
        NavActions.mobileNavActiveLinks(true);
    };

    render() {
        if (!this.props.isActive) {
            if (!this.props.localeOptions || !this.props.localeOptions.length || this.props.localeOptions.length === 1) {
                console.warn('[EGH] localeOptions array was invalid or empty. Hiding locale...');
                return <div />;
            }
        }
        const {currentLocale, locales} = getCurrentLocale(this.props.localeOptions, this.props.locale, this.context.messages.locale);
        const classes = `${this.context.isMobile ? 'rightnav-bg-color' : 'bg-color dropdown'} ${this.props.isActive ?
            'active' : ''} ${locales.length <= 0 ? 'hidden' : ''}`;
        const ulClasses = `locale-list bg-color ${this.context.isMobile ? 'mobile-list' : ''} ${this.props.hideCallToAction ?
            'ul-right' : 'ul-left'} ${this.props.hideSignIn && this.props.hideCallToAction ? 'ul-right-0' : ''}`;
        return (
            <div id="locale" className={classes}>
                {!this.context.isMobile ? <LocaleIcon currentLocale={currentLocale} isActive={this.props.isActive} /> : ''}
                <ul className={ulClasses}>
                    {this.context.isMobile ?
                        <li
                            role="menuitem"
                            id="mobileHeading"
                            className="mobile-heading"
                            onClick={this.close}><a><span>{currentLocale}</span></a>
                        </li> : ''}
                    {locales.map((locale, i) => {
                        if (locale.lang && locale.lang !== this.props.locale && locale.name) {
                            const href = this.getHref(locale);
                            const lang = locale.lang.replace(/_/, '-');
                            return (
                                <li
                                    className={`${this.context.isMobile ? 'mobile-list-item' : ''}`}
                                    key={`lang-${lang}`}
                                    data-lang={lang}>
                                    <a href={href} onClick={this.onClick} data-index={i} className="text-color-hover text-color-nonactive">
                                        <span>{locale.name}</span>
                                    </a>
                                </li>
                            );
                        } else if (!this.warned && (!locale.name || !locale.lang)) {
                            if (process.env.NODE_ENV !== 'production') {
                                console.warn('locale object had an invalid [name] or [lang]! Ensure that the localeOptions are correct.');
                            }
                            this.warned = true;
                        }
                        return undefined;
                    })}
                </ul>
            </div>
        );
    }
}
